module.exports = "./images/right-arrow.svg";